import React from "react";

export const MandatoryFieldsText = () => {
  return <p className="mandatory">* All fields are mandatory</p>;
};
